/**
 * Cosmetic-only heuristic: does this assistant message read as a clarifying
 * question the officer needs to answer before the agent can usefully
 * continue, rather than a completed answer or confirmation?
 *
 * There is no structural signal for this — clarifying questions are plain
 * AIMessages, identical in shape to any other answer. A false
 * positive/negative here only affects a visual nudge, never gating logic
 * (the chat is already turn-based; nothing here blocks sending the next
 * message), so a simple heuristic is an acceptable, low-stakes choice.
 */
export function isClarifyingQuestion(content: string): boolean {
  const trimmed = content.trim()
  if (!trimmed.endsWith("?")) return false
  // A long message that happens to end in a question is more likely a
  // substantive answer with a trailing rhetorical/offer-to-help question
  // ("...Let me know if you'd like anything else?") than a genuine blocker.
  if (trimmed.length > 280) return false
  return true
}
